module.exports = "<declaracion-co #declaracionC\n    [error]='error'\n    [deltaPeso]='declaracion.deltaPeso'\n    [prospecto]='prospecto'\n    [dni]='dni'\n    [idSolicitud]='idSolicitud'\n    [preguntasPrimerNivel]='preguntas'\n    [resultado]='declaracion.conclusiones'\n    title=\"Declaración de asegurabilidad\"\n    image=\"../../assets/images/img-card-declaracion-aseg.png\" \n    [nomOcupacion]='declaracion.nomOcupacion'>\n</declaracion-co>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/declaracion/declaracion.component.html
// module id = ./src/app/declaracion/declaracion.component.html
// module chunks = main